import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Carga los datos iniciales del formulario desde el backend:
 * tiendas, categorías, permisos de gondola/etiqueta y username.
 *
 * Si no hay token válido, redirige al login.
 */
export function useFormData() {
    const [usernameStr, setUsernameStr]       = useState('');
    const [categoryList, setCategoryList]     = useState({});
    const [tiendaList, setTiendaList]         = useState({});
    const [tienda, setTienda]                 = useState(null);
    const [category, setCategory]             = useState(null);
    const [gondolaEnabled, setGondolaEnabled] = useState(false);
    const [etiquetaEnabled, setEtiquetaEnabled] = useState(false);
    const [loading, setLoading]               = useState(true);
    const [error, setError]                   = useState(null);
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const access   = userData?.access;

        if (!access) {
            window.location.href = '/login';
            return;
        }

        (async () => {
            try {
                const result = await axios.get(
                    process.env.REACT_APP_BACK_API_URL + 'token/login/usuario',
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${access}`,
                        },
                    }
                );

                const data = result.data;

                setGondolaEnabled(data.gondola);
                setEtiquetaEnabled(data.etiqueta);
                setUsernameStr(data.user);

                // Construir mapa id → nombre para tiendas
                const tiendas = {};
                data.tiendas.forEach((t) => {
                    tiendas[t.id] = t.nombre;
                });
                setTiendaList(tiendas);

                // Construir mapa id → nombre para categorías
                const categorias = {};
                data.categorias.forEach((c) => {
                    categorias[c.id] = c.nombre;
                });
                setCategoryList(categorias);

                // --- SOLO SETEAMOS POR DEFECTO SI NO ESTÁ INICIALIZADO ---
                if (!initialized) {
                    if (data.tiendas.length > 0) {
                        const tiendasResponse = data.tiendas;
                        setTienda(currentTienda => {
                            if (!currentTienda && tiendasResponse.length > 0) {
                                return tiendasResponse[0].id;
                            }
                            return currentTienda; // Mantenemos el que ya estaba
                        });
                    }
                    if (data.categorias.length > 0) {
                        setCategory(data.categorias[0].id);
                    }
                    setInitialized(true); // Bloqueamos futuros reseteos
                }
            } catch (e) {
                console.error('Error al cargar datos del formulario:', e);
                setError(e);
            } finally {
                setLoading(false);
            }
        })();
    }, [initialized]);

    return {
        usernameStr,
        categoryList,
        tiendaList,
        tienda,        setTienda,
        category,      setCategory,
        gondolaEnabled,
        etiquetaEnabled,
        loading,
        error,
    };
}